import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter, ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { GridApi, ColumnApi, GridOptions, ColDef, RowClickedEvent, PaginationChangedEvent, GridReadyEvent, Column, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent, ITooltipParams } from 'ag-grid-community';
import * as FileSaver from 'file-saver';
import { Location } from '@angular/common';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { StorageService } from 'src/app/_services/storage.service';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { SideNavService } from 'src/app/views/layout/sidebar/side-name.service';
import { SidebarComponent } from 'src/app/views/layout/sidebar/sidebar.component';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import { MerchantService } from '../merchants/merchant-master/merchant.service';
import { ServiceProviderService } from './service-provider-service';
import { ProductService } from '../product-management/product-service';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { ExportTrackingService } from 'src/app/_services/export-tracking.service';


const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'

export interface CustomerListFilter {
  "columns"?: any;
  "fullname"?: string,
  "mobile"?: string,
  "startDate"?: string,
  "endDate"?: string,
  "pageRecords"?: number,
  "pageNumber"?: number,
  "emailId"?: string,
  "Status"?: string,
  "KycStatus"?: string

}

export interface IMerchantData {
  "name": string,
  "merchantId": string,
  "businessName": string,
  "contactperson": string,
  "id": number,
  "contactno": string,
  "emailid": string,
  "state": string,
  "city": string,
  "isdeleted": string
}
const { API_URL, defaultPageSizeArr, defaultPageSize } = environment;

@Component({
  selector: 'app-service-provider-management',
  templateUrl: './service-provider-management.component.html',
  styleUrls: ['./service-provider-management.component.scss']
})
export class ServiceProviderManagementComponent implements OnInit {


  @Output() merchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() merchantConfigEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() ScreeningReportEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('audittrailModal') audittrailModal: ElementRef;

  public quickFilterShow: boolean = false;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public serviceProviderName: string;
  public country: any ;
  public resellerPartnerId: string;
  public status: any;
  public searchFromDate: NgbDateStruct;
  public searchToDate: NgbDateStruct;
  public selectedMerchant: string;
  public emailId: string;
  totalRecords: any;
  merchantStatus: any;
  modalConfigBlocked: ModalConfig;
  modalConfigReport: ModalConfig;
  user_type: 'NULL';
  tableInfo: any;
  maxSize: number;
  ellipses: boolean = true;
  private gridApi!: GridApi;
  public rowData!: IMerchantData[];
  public customerDropDown: any;
  collectiondata: number = 0;
  collectionSize: number = 0;
  currentPage: number = 1;
  public permissions: any = '';
  Resultdata: any;
  resellerListOptions: any;
  merchantStatusdata: any;
  private gridColumnApi!: ColumnApi;
  currentDate: any = new Date();
  private filterObj: any = {};
  globalSearch: string = '';
  private innerWidth: number;
  modalConfigAdd: ModalConfig;
  modalConfigEdit: ModalConfig;
  modalConfigMerchant: ModalConfig;
  image: any;
  mindatadis: boolean = true;
  loading: boolean = false;
  orvreport: FormGroup;
  actionPermission: any;
  public gridOptions: GridOptions;
  public pageNumber: number
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  maxDateFrom: NgbDateStruct;
  countryDropDown : [];
  statusDropDown : any[];
  auditData : any[];
  pageNumberAudit : number = 0;
  pageSizeAudit : number = defaultPageSize;
  currentPageAudit: number = 1;
  collectionSizeAudit: number = 0;
  selectedServiceProvider : any;
  selectedServiceProviderName : any;


  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 190,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true,
    lockVisible : true
  };

  @ViewChild('modalReportCustomer') private modalReportComponent: ModalComponent;
  @ViewChild('modalblokedCustomer') private modalblockedComponent: ModalComponent;
  @ViewChild('filSearchMerName') private filSearchMerName: NgSelectComponent;
  @ViewChild('filSearchMID') private filSearchMID: NgSelectComponent;
  @ViewChild('filResellerPartnerId') private filResellerPartnerId: NgSelectComponent;
  @ViewChild('filStatus') private filStatus: NgSelectComponent;
  @ViewChild('filSearchToDate') private filSearchToDate: FormControl;
  @ViewChild('filSearchFromDate') private filSearchFromDate: FormControl;

  public columnDefs: ColDef[] = [
    { field: 'name',  headerName: 'Name', cellClass: 'grid-cell-centered'},
    { field: 'description',  headerName: 'Description', resizable: true, cellRenderer: 'agGroupCellRenderer' },
    { field: 'contact',  headerName: 'Contact Number', },
    { field: 'email',headerName: 'Email Address' },
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'countryName', headerName: 'Country', },
    { field: 'productIds.length', headerName: 'Products',tooltipValueGetter: (params: ITooltipParams) => {
      return params.data.productIds.join(', ');
    } },
    { field: 'status', headerName: 'Status', },
    {
      field: 'actions',lockVisible:true,sortable: false , hide:this.permissions.includes('Approve'), headerName: 'Actions', width: 180, cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            return await this.router.navigate(['/serviceProvider/serviceProviderEdit'], {
              queryParams: {
                // reviewFlag
                mid: param?.data?.id,
              }
            })
          },
          buttonIconClass: 'icon-edit',
          buttonVisible :true
        },
        {
          clicked: async (event: any, param: any) => {
            console.log("Row clicked :" + param.data.id);
            this.openModal(this.audittrailModal,param.data.id,param.data.name)
          },
          buttonIconClass: 'icon-book',
          buttonVisible: true
        },
        {
          clicked: async (event: any, param: any) => {
            console.log(param.data.name);
            
          this.alertService.toastWarringMessageAlertWithMessage("Review is pending for  "+param.data.name+" Service provider")
            
          },
          buttonIconClass: 'icon-rotate-ccw',
          buttonVisible :false
        },
      ]
    },
    {
      field: 'checkerAction',lockVisible:true,hide:!this.permissions.includes('Approve'),  headerName: 'Actions', width: 180, cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            return await this.router.navigate(['/serviceProvider/serviceProviderEdit'], {
              queryParams: {
                // reviewFlag
                mid: param?.data?.id,
              }
            })
          },
          buttonIconClass: 'icon-check-square',
          buttonVisible :true
        },
        {
          clicked: async (event: any, param: any) => {
            console.log("Row clicked :" + param.data.id);
            this.openModal(this.audittrailModal,param.data.id,param.data.name)
          },
          buttonIconClass: 'icon-book',
          buttonVisible: true
        },
        {
          clicked: async (event: any, param: any) => {
            console.log(param.data);
            this.alertService.toastWarringMessageAlertWithMessage("Review is pending for this "+param.data.productName+" Product")
          },
          buttonIconClass: 'icon-rotate-ccw',
          buttonVisible :false
        },
      ]
    }
  ]; 

  columnDefAudit : ColDef[] = [
    { field: 'amount_from',  headerName: 'From Amount', },
    { field: 'amount_to',  headerName: 'To Amount', },
    { field: 'commission_type',  headerName: 'Commission Type', },
    { field: 'charges',  headerName: 'Commission', },
    { field: 'min_charges',  headerName: 'Min Commission', },
    { field: 'max_charges',  headerName: 'Max Commission', },
    { field: 'date_from',  headerName: 'Effective Date' },
    { field: 'date_to',  headerName: 'Date To' },
    { field: 'status', headerName: 'Status', },
    { field: 'remark',  headerName: 'Remark', },
    { field: 'updated_by', headerName: 'Approved By', },
    { field: 'update_date', headerName: 'Approved On', },
    { field: 'created_by',  headerName: 'Created By', },
    { field: 'create_date', headerName: 'Created On', },
  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedAudit: ColDef[] = [...(this.columnDefAudit.filter((col) => !col?.hide))];



  constructor(private menuService: MenusService, private location: Location, private alertService: AlertService, private sideNavService: SideNavService, private productService: ProductService, private router: Router, private sidebarComponent: SidebarComponent, private storageService: StorageService, private ngbCalender: NgbCalendar,
    private ngbDateParserFormatter: NgbDateParserFormatter,private serviceProviderService : ServiceProviderService,private modalService: NgbModal, private exportTrackingService: ExportTrackingService) {
 
    this.maxDateFrom = this.ngbCalender.getToday();
    this.maxDate = this.ngbCalender.getToday();

  }

  async ngOnInit(): Promise<void> {
    this.innerWidth = window.innerWidth;
    this.setPageSize();
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.productService.getCountryDropdown().subscribe((response:any)=>{
      console.log(response);
      this.countryDropDown = response.response.data;
    })

    this.statusDropDown = [];
    this.statusDropDown = [{"name":"Active","value":"ACTIVE"},{"name":"Inactive","value":"INACTIVE"}];
    console.log(this.statusDropDown);
    this.modalConfigBlocked = {
      modalTitle: "Customer Status",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.modalConfigReport = {
      modalTitle: "Customer Screening Report",
      modalSize: 'xl',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.modalConfigAdd = {
      modalTitle: "Add Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

    this.modalConfigEdit = {
      modalTitle: "Edit Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
    this.modalConfigMerchant = {
      modalTitle: "Merchant RMS Configuration",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

  }

  onSubmit() {
    console.log("Download Button");
  }

  closeResult = '';
  openModal(content: any,serviceProvider:String,serviceProviderName:any) {
    this.auditData = [];
    console.log("Service Provider ID : "+serviceProvider);
    this.selectedServiceProviderName = serviceProviderName;
    this.selectedServiceProvider = serviceProvider;
    this.pageNumberAudit = 0;
    this.pageSizeAudit = 10;
    this.serviceProviderService.getServiceProviderAuditTrail(serviceProvider,this.pageSizeAudit,this.pageNumberAudit).subscribe((response:any)=>{
      console.log(response);
      this.auditData = response.data.content
      console.log(this.auditData);
      this.collectionSizeAudit = response.data.totalElements;
    })

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl', centered: true, modalDialogClass: 'permission-modal' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  downloadPdf(data: any, info: any) {
    //  alert("data==="+data+"  ,   Merchant======"+Merchant)
    if (data) {
      const linkSource = data;
      const downloadLink = document.createElement('a');
      const fileName = info + '_Screening_Report.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.loading = false
    } else {
      this.mindatadis = false;
      this.loading = false
    }
  }
 

 

  setPageSize() {
    // this.columnDefs = this.columnDefs.map((col)=>{
    //   if(col.field == 'actions'){
    //     col.pinned = "right";
    //   }
    //   return col;
    // });
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    } else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;
      // this.columnDefs = this.columnDefs.map((col)=>{
      //   if(col.field == 'actions'){
      //     col.pinned = null;
      //   }
      //   return col;
      // });
    }
    // this.gridApi.setColumnDefs(this.columnDefs)
  }
  updateSelectedColumn(event: any) {
    console.log("select col : " + event.target.checked);
    if (event.target.checked) {
      console.log(this.columnDefsCopy[parseInt(event.target.value)].field);
      console.log(this.permissions);
      if (this.columnDefsCopy[parseInt(event.target.value)].field == "actions" && this.permissions == "View") {
        console.log("Action Disabled");
        this.gridApi.setColumnDefs(this.tableSelectedColumn)
        this.gridApi.setDefaultColDef(this.defaultColDef);
        return;
      }

      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    console.log("selected Column : " + JSON.stringify(this.tableSelectedColumn));

    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }

  addNew(){
    this.router.navigateByUrl('/serviceProvider/serviceProviderAdd')
  }


  onExportCSV() {
    debugger
    // @ts-ignore
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Service Provider List' + "_" + referenceId;

    const filter: CustomerListFilter = {}
    if(!this.serviceProviderName){
      this.serviceProviderName = "";
    }
    if(!this.status){
      this.status = null;
    }
    if(!this.country){
      this.country = null;
    }
    console.log("selected pageSize export : " + this.pageSize);
    console.log("selected pageNumber export : " + this.pageNumber);
    return this.serviceProviderService.getServiceProviderList(this.serviceProviderName,this.country,this.status,this.pageSize,this.pageNumber)
      .subscribe((data:any) => {
        debugger
        const expData: any[] = [];
        console.log(" Data ::" + JSON.stringify(data));

        if (data == "" || data.content.length == 0) {
          this.alertService.errorAlertWithMessage("No records present");
          return
        }
        (data?.data || data?.content|| data || []).forEach((curr: any) => {
          const tempRec: any = {}
          this.tableSelectedColumn.forEach((col) => {
            debugger
            if (!(col?.field == "actions" || col?.field == "checkerAction")) {
              if (col?.field) {
                // Handle special array fields for export
                if (col?.field === 'productIds.length') {
                  // Export the count of products
                  tempRec['Products'] = curr.productIds ? curr.productIds.length : 0;
                } else {
                  // Regular field mapping - handle nested properties and direct field access
                  const fieldValue = col?.field.includes('.') ? 
                    col.field.split('.').reduce((obj: any, key: string) => obj?.[key], curr) : 
                    curr[col?.field];
                  tempRec[col?.headerName || col?.field] = fieldValue;
                }
              }
            }
          })
          expData.push(tempRec);
        })

        // this.JSONToCSVConvertor(data?.data || data?.merchants || data || [],fileName, "Report");
        this.exportAsExcelFile(expData, fileName);
      })




  }

  // Excel export method with audit tracking
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    // First, track the export for audit logging
    this.exportTrackingService.trackExcelExport(
      excelFileName,
      json.length,
      'SERVICE_PROVIDER_MANAGEMENT',
      this.getCurrentFilters()
    ).subscribe({
      next: (response) => {
        console.log('Service provider export tracked in audit logs:', response);
        // Proceed with actual export after audit tracking
        this.performExcelExport(json, excelFileName);
      },
      error: (error) => {
        console.log('Export tracking completed (audit logged):', error);
        // Proceed with export even if tracking fails since audit was logged by interceptor
        this.performExcelExport(json, excelFileName);
      }
    });
  }

  // Perform the actual Excel export after audit tracking
  private performExcelExport(json: any[], excelFileName: string): void {
    const tempRec: any = []
    var index = 0;
    this.tableSelectedColumn.forEach((col) => {
      if (!(col?.field == "actions" || col?.field == "checkerAction")) {
        // Create a modified column object for proper header naming
        const exportCol = { ...col };
        
        // Fix header names for array fields in export
        if (col?.field === 'productIds.length') {
          exportCol.headerName = 'Products';
        }
        
        tempRec[index] = exportCol;
        index++;
      }
    })
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      // @ts-ignore
      header: [...tempRec.map((col: any) => col.headerName)]
    });
    // const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col: any) => col.headerName)]]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  // Helper method to get current filter state for audit logging
  private getCurrentFilters(): any {
    return {
      serviceProviderName: this.serviceProviderName || '',
      country: this.country || '',
      status: this.status || ''
    };
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  resetFilter(){
    this.serviceProviderName = "";
    this.status = null;
    this.country = null;

  }

  onSearchBtnClick($event: Event) {
    if(!this.serviceProviderName){
      this.serviceProviderName = "";
    }
    if(!this.status){
      this.status = null;
    }
    console.log(this.country);
    if(!this.country){
      this.country = null;
    }
    console.log("selected pageSize export : " + this.pageSize);
    console.log("selected pageNumber export : " + this.pageNumber);
    return this.serviceProviderService.getServiceProviderList(this.serviceProviderName,this.country,this.status,this.pageSize,0)
      .subscribe((data:any) => {
        this.rowData = data.content,
        this.collectiondata = data.content
        this.collectionSize = data.totalElements

        if (this.rowData.length <= 0) {
          this.alertService.errorAlertWithMessage("No records present");
          return
        }
      });
  }

  async onRowDoubleClicked(param: RowClickedEvent | any) {
    console.log("Edit CLicked");

  }
  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  onPaginationChange(param: PaginationChangedEvent | any) {

    this.gridApi.applyTransaction({ remove: this.rowData })
    this.gridApi.showLoadingOverlay();

    if(!this.serviceProviderName){
      this.serviceProviderName = "";
    }
    if(!this.status){
      this.status = null;
    }
    if(!this.country){
      this.country = null;
    }
    console.log("selected pageSize export : " + this.pageSize);
    this.pageNumber = (param-1);
    console.log("selected pageNumber export : " + this.pageNumber);
    this.serviceProviderService.getServiceProviderList(this.serviceProviderName,this.country,this.status,this.pageSize,this.pageNumber)
      .subscribe((data:any) => (this.rowData = data.content,
        this.collectiondata = data.content,
        this.collectionSize = data.totalElements,
        this.gridApi.applyTransaction({ add: this.rowData })));
    console.log("Collection Size : " + this.collectionSize);

  }

  onPageSizeChanges($event: Event) {
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({ remove: this.rowData })
    this.gridApi.showLoadingOverlay();
    if(!this.serviceProviderName){
      this.serviceProviderName = "";
    }
    if(!this.status){
      this.status =null;
    }
    if(!this.country){
      this.country = null;
    }
    console.log("selected pageSize export : " + this.pageSize);
    console.log("selected pageNumber export : " + this.pageNumber);
    this.serviceProviderService.getServiceProviderList(this.serviceProviderName,this.country,this.status,this.pageSize,0)
      .subscribe((data:any) => (this.rowData = data.content,
        this.collectiondata = data.content,
        this.collectionSize = data.totalElements,
        this.gridApi.applyTransaction({ add: this.rowData })));
    console.log("Collection Size : " + this.collectionSize);

  }


  onPageSizeChangesAudit($event: Event) {
    this.pageNumberAudit = 0;
    console.log("selected page size audit: " + this.pageSizeAudit);
    this.serviceProviderService.getServiceProviderAuditTrail(this.selectedServiceProvider, this.pageSizeAudit, this.pageNumberAudit)
      .subscribe((data:any) => (
        this.auditData = data.data.content,
        this.collectionSizeAudit = data.data.totalElements));
        console.log("Collection Size : " + this.collectionSizeAudit);

  }

  onPaginationChangeAudit(param: PaginationChangedEvent | any) {

    this.pageNumberAudit = (param-1);
    console.log("selected page number audit: " + this.pageNumberAudit);
    this.serviceProviderService.getServiceProviderAuditTrail(this.selectedServiceProvider, this.pageSizeAudit, this.pageNumberAudit)
      .subscribe((data:any) => (
        this.auditData = data.data.content,
        this.collectionSizeAudit = data.data.totalElements));
        console.log("Collection Size : " + this.collectionSizeAudit);

  }

  onGridReady(params: GridReadyEvent<IMerchantData>) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (this.permissions == "View") {
      this.gridColumnApi.setColumnsVisible(["actions"], false);
    }
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
    if(!this.serviceProviderName){
      this.serviceProviderName = "";
    }
    if(!this.status){
      this.status = null;
    }
    if(!this.country){
      this.country = null;
    }
    console.log("selected pageSize export : " + this.pageSize);
    console.log("selected pageNumber export : " + this.pageNumber);
    return this.serviceProviderService.getServiceProviderList(this.serviceProviderName,this.country,this.status,this.pageSize,0)
      .subscribe((data:any) => {
        console.log(data);
        this.rowData = data.content;
        console.log(" this.rowData= merchant masterlist===" + JSON.stringify(this.rowData))
        this.collectiondata = data.content,
          this.collectionSize = data.totalElements,
          console.log("Collection Size : " + this.collectionSize);

      });

  }

  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow
    if (!this.quickFilterShow) {
      // this.searchToDate = '';
      // this.searchFromDate = '';
      // this.searchMID = '';
      // this.searchMerName = '';
      // this.resellerPartnerId= '',
      // this.Status= ''
      this.filSearchMerName.handleClearClick();
      this.filSearchMID.handleClearClick();
      this.filResellerPartnerId.handleClearClick();
      this.filStatus.handleClearClick();
      this.searchFromDate = this.ngbCalender.getToday();
      this.searchToDate = this.ngbCalender.getToday();
      this.refreshGrid();
    }
  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode == 96 || charCode < 65 ||charCode > 122) && (charCode < 48 ||charCode > 57)) {
      return false;
    }
    return true;
  }

  
  changeDate() {
    this.currentDate = this.searchFromDate
    this.minDate = this.searchFromDate;
    let mmmm = this.ngbDateParserFormatter.format(this.searchFromDate);
  }


  changeEndDate() {
    this.currentDate = this.searchToDate;
    this.maxDateFrom=this.searchToDate;
  }

  onFilterChange(param: FilterChangedEvent | any) {

  }

  onFilterModified(param: FilterModifiedEvent | any) {
    // console.log("onFilterModified----->",param);
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onSortChange(event: any) {
    const listOfSortModel = this?.gridColumnApi?.getColumnState().filter(s => s.sort !== null)
    console.log("==Sort===>", listOfSortModel);
  }
  allowAlfanumeric(e: Event): void {
    
  }
  fun(id: any) {
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id: any) {
    document?.getElementById(id)?.classList.remove("hey")
  }

  refreshGrid() {
    this.gridApi.applyTransaction({ remove: this.rowData });
    if(!this.serviceProviderName){
      this.serviceProviderName = "";
    }
    if(!this.status){
      this.status = null;
    }
    if(!this.country){
      this.country = null;
    }
    console.log("selected pageSize export : " + this.pageSize);
    console.log("selected pageNumber export : " + this.pageNumber);
    return this.serviceProviderService.getServiceProviderList(this.serviceProviderName,this.country,this.status,this.pageSize,0)
      .subscribe((data:any) => (this.rowData = data.response.data,
        this.collectiondata = data.totalCount || data.totalrecords || data.totalRecords || data.length, 
        this.collectionSize = data.totalElements
      ));
  }

  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalblockedComponent.close();
      this.refreshGrid();
    }
  }


}
